import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import { ReactComponent as Logo } from 'svg/logo.svg';

import './style.css';

const Footer = () => {
  return (
    <footer id="footer" className="footer-desktop">
      <div className="footer-wrapper wrapper-full">
        <section className="documents">
          <header>
            <h5>Privacy</h5>
          </header>
          <ul className="footer-navigation-documents">
            <li>
              <Link to="/terms-of-service">Terms & Conditions</Link>
            </li>
          </ul>
        </section>

        <section className="navigation">
          <header>
            <h5>Navigation</h5>
          </header>
          <ul className="footer-navigation">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </section>

        <section className="social">
          <header>
            <h5>Social</h5>
          </header>
          <ul className="footer-navigation-social">
            <li>
              <a href="/">Twitter</a>
            </li>
            <li>
              <a href="/">Facebook</a>
            </li>
            <li>
              <a href="/">Linkedln</a>
            </li>
          </ul>
        </section>

        <section className="logo">
          <NavLink to="/">
            <Logo />
          </NavLink>
          <span>Copyright 2020 - Ciudad de México, México.</span>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
